import {
    http
} from '@/utils/http'

export function getTokenV3(data) {
    return http.get('prod-api/user/v3/api-key/transform', data)
}
export function mg_login(data) {
    return http.post('prod-api/user/oauth/mg_music', data)
}
export function captcha(data) {
    return http.post('prod-api/user/captcha', data)
}
export function register(data) {
    return http.post('prod-api/user/register', data)
}
export function login(data) {
    return http.post('prod-api/user/login', data)
}
export function googleLogin(data) {
    return http.post('prod-api/user/login/google', data)
}
export function discordLogin(data) {
    return http.post('prod-api/user/oauth/callback/discord', data)
}
export function loginByEmail(data) {
    return http.post('prod-api/user/login/email/captcha', data)
}